<template>
  <v-dialog v-model="dialog" persistent max-width="600px">
    <template v-slot:activator="{ on }">
      <v-btn v-on="on" icon>
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </template>

    <v-card>
      <v-card-title>Create new {{ this.formattedType }}</v-card-title>
      <v-card-text>
        <v-row>
          <v-col>
            <v-text-field
              v-model="newMember.username"
              label="Username"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-text-field
              v-model="newMember.password"
              label="Password"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <span v-if="$store.state.errors.state" class="red--text">{{
              $store.state.errors.message
            }}</span>
          </v-col>
        </v-row>

        <v-row>
          <v-spacer></v-spacer>
          <v-col class="text-right">
            <v-btn class="mx-5" @click="closeCreateMember">
              Close
            </v-btn>
            <v-btn
              class="mx-5"
              @click="createMember"
              :disabled="!newMember.username || !newMember.password"
            >
              Save
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'DialogCreateNewMember',

  data: () => ({
    dialog: false,
    newMember: {
      username: null,
      password: null
    }
  }),

  props: {
    type: {
      type: String,
      required: false,
      default: 'partners'
    }
  },

  computed: {
    formattedType() {
      return (
        this.type.charAt(0).toUpperCase() +
        this.type.slice(1, this.type.length - 1).toLowerCase()
      );
    }
  },

  methods: {
    createMember() {
      console.log('createMember() triggered');
      this.$store.dispatch('errors/reset');
      this.$store.dispatch('members/create', {
        type: this.type.slice(0, this.type.length - 1),
        ...this.newMember
      });
    },

    closeCreateMember() {
      this.$store.dispatch('errors/reset');
      this.newMember.username = null;
      this.newMember.password = null;
      this.$emit('getMembers');
      this.dialog = false;
    }
  }
};
</script>
